import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const dialogTitleStyles: SxProps<Theme> = { fontWeight: 700, pb: 1.5 };


/**
 * Takes whatever height the title and the toolbar leave, and nothing more: the stage inside
 * is sized from this box's measured size, so it must not grow with its own content.
 */
export const stageAreaStyles: SxProps<Theme> = {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    pb: 1,
    // The artwork runs to the very top of its own box -- the figure's head is on the
    // frame -- so without a gap here it reads as colliding with the title above it.
    //
    // Doubled selector, because MUI ships `.MuiDialogTitle-root + .MuiDialogContent-root
    // { padding-top: 0 }`, which outweighs a plain sx class and silently wins: the padding
    // is in the stylesheet and computes to 0px.
    '&&': { pt: 4 },
};

/**
 * The artwork with the canvas laid exactly over it. Its width and height are set from the
 * measured area in the component, at the artwork's own proportions, so a point on the
 * canvas and the same point on the picture are one and the same.
 */
export const stageStyles: SxProps<Theme> = {
    position: 'relative',
    // The outline is grey line drawing on a transparent background; on a dark surface the
    // figure would all but disappear. It prints on white, so it is drawn on white.
    backgroundColor: 'common.white',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    overflow: 'hidden',
};

export const outlineImageStyles: SxProps<Theme> = {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    userSelect: 'none',
    pointerEvents: 'none',
};

export const canvasStyles: SxProps<Theme> = {
    position: 'absolute',
    inset: 0,
    display: 'block',
    width: '100%',
    height: '100%',
    // Without this a finger scrolls or zooms the page instead of drawing.
    touchAction: 'none',
    cursor: 'crosshair',
};

export const dialogActionsStyles: SxProps<Theme> = {
    px: 3,
    pb: 3,
    pt: 1,
    flexWrap: 'wrap',
    gap: 1,
};

/** Pushes Cancel and Done to the far side, away from the two that change the drawing. */
export const spacerStyles: SxProps<Theme> = { flex: 1 };
